/* eslint-disable react/no-array-index-key */

import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import BundleItem from './BundleItem';
import BundleSavings from './BundleSavings';

import { useWindowSize } from '../../../../utils/hooks';
import {
	getBundleCollections,
	getProductsByHandleList,
	createMetaFieldsMap
} from '../../../../utils';

const ns = `bundle-list`;

const BundleList = ({
	product, price, compareAtPrice, setSelectedBundleItems,
}) => {
	const rootClassnames = classNames({ [`${ ns }`]: true });
	const hasBundleSavings = compareAtPrice && price !== compareAtPrice;
	const { width } = useWindowSize();
	const metafields = createMetaFieldsMap(product?.metafields);

	const isMounted = useRef();
	const bundleListRef = useRef();
	const [items, setItems] = useState([]);

	/**
	 * Sets the overflow of the bundle-list container based on select menu events.
	 * @param {string} payload | the overflow property
	 */
	const setBundleListOverflow = payload => {
		if (items.length >= 4 && width >= 992) {
			const bundleList = bundleListRef.current;
			const scrollbarWidth = (window.innerWidth - document.body.clientWidth);

			bundleList.style.overflow = payload;
			bundleList.style.paddingRight = `${ payload === 'hidden' ? scrollbarWidth : 0 }px`;
		}
	};

	/**
	 * Sets/updates the selectedBundleItems state to an array of objects that
	 * is compatible with customAttributes
	 * @param {object} payload | the selected option from BundleItem
	 */
	const setBundleSelections = payload => {
		setSelectedBundleItems(current => {
			return [
				...current.filter(object => {
					return (
						object.key !== `${ payload.sku_code } SKU ${ payload.sku_index }`
						&& object.key !== `_${ payload.sku_code } SKU ${ payload.sku_index } Product Name`
					);
				}),
				...[
					{ key: `${ payload.sku_code } SKU ${ payload.sku_index }`, value: payload.value },
					{ key: `_${ payload.sku_code } SKU ${ payload.sku_index } Product Name`, value: payload.product_name },
				],
			];
		});
	};

	useEffect(() => {
		isMounted.current = true;

		const getBundleItems = async() => {
			const response = await Promise.all([
				getBundleCollections(metafields?.custom_fields?.bundle_collection),
				getProductsByHandleList(metafields?.custom_fields?.bundle_product_with_variants, `variants`),
				getProductsByHandleList(metafields?.custom_fields?.bundle_product_no_variant, `no-variant`),
				getProductsByHandleList(metafields?.custom_fields?.bundle_product_unique_variant, `unique-variant`),
			]);

			response.map(_response => {
				if (!_response) return false;

				return _response.map(_items => {
					return setItems(current => {
						return [
							...current,
							_items,
						];
					});
				});
			});
		};

		getBundleItems();

		return () => {
			isMounted.current = false;
		};
	}, []); // eslint-disable-line

	return (
		<div className={rootClassnames} ref={bundleListRef}>
			{items && items.map((item, index) => {
				return (
					<BundleItem
						index={index}
						key={`${item.id}_${index}`}
						item={item}
						setBundleSelections={setBundleSelections}
						setBundleListOverflow={setBundleListOverflow}
					/>
				);
			})}

			{hasBundleSavings && (
				<BundleSavings price={price} compareAtPrice={compareAtPrice} />
			)}
		</div>
	);
};

export default BundleList;
